import { defineMessages } from 'react-intl';

export default defineMessages({
  PageHeader: {
    id: 'PageHeader',
    defaultMessage: 'Careers',
  },
  SomethingWentWrong: {
    id: 'SomethingWentWrong',
    defaultMessage: 'Something went wrong',
  },
  ShareLinkedin: {
    id: 'ShareOnLinkedin',
    defaultMessage: 'Share on LinkedIn',
  },
});
